import React from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
import { Link } from 'react-router';
import NavBarNew from '../../components/toolbars/NavBarNew';
import OrganizationsList from './OrganizationsList';
import CreateOrganizationButton from '../../components/buttons/CreateOrganizationButton';
import CurrentUserContext from '../../contexts/CurrentUser';
class TabLink extends React.Component {
  render() {
    const { to, title, activeTab } = this.props;
    const classCompile = `nav-link ${
      activeTab && activeTab.length ? 'active' : ''
    }`;

    return (
      <Link className={classCompile} to={to}>
        {title}
      </Link>
    );
  }
}

const AdminTabs = props => {
  return (
    <div className="col-xs-12 clearfix">
      <nav className="nav nav-pills clearfix">
        <TabLink
          activeTab={props.pathname.match('/admin/org')}
          to="/admin/organizations"
          title="Organizations"
        />
        <TabLink
          activeTab={props.pathname.match('/admin/plan')}
          to="/admin/plans"
          title="Plans"
        />
      </nav>
    </div>
  );
};
AdminTabs.propTypes = {
  pathname: PropTypes.string,
};

// export const Organizations = props => (
//   <CurrentUserContext.Consumer>
//     {({ currentUser }) => {
//       return (
//         <div>
//           <h1>Organizations</h1>
//           <CreateOrganizationButton currentUser={currentUser} />
//           <OrganizationsList {...props} />
//         </div>
//       );
//     }}
//   </CurrentUserContext.Consumer>
// );

export const Organizations = props => {
  return (
    <div>
      <h1>Organizations</h1>
      <CreateOrganizationButton currentUser={props.currentUser} />
      <OrganizationsList {...props} />
    </div>
  );
};

// const AdminPanelOrganizations = props => {
//   return (
//     <div>
//       Hello
//     </div>
//   );
// };

class Dashboard extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
    pathname: PropTypes.string,
    currentUser: PropTypes.instanceOf(Map),
  };

  render() {
    const { children, pathname } = this.props;

    return (
      <div>
        <NavBarNew />
        <div className="main-container" style={{ marginLeft: 50 }}>
          <div className="col-xs-12 p-3 clearfix">
            <h2 className="mb-0">Admin Dashboard</h2>
            <AdminTabs pathname={pathname} />
          </div>
          <div className="col-xs-12 p-3">{children}</div>
        </div>
      </div>
    );
  }
}

class AdminContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
    location: PropTypes.object,
    params: PropTypes.object,
  };

  render() {
    const {
      dispatch,
      children,
      currentUser,
      location: { pathname },
      params: { organizationId },
    } = this.props;

    if (!currentUser || currentUser && currentUser.get('role_id') !== 1) {
      return null;
    }
    console.log('this', currentUser && currentUser.toJSON()); 
    return (
      <Dashboard
        dispatch={dispatch}
        pathname={pathname}
        organizationId={organizationId}
      >
        {children}
      </Dashboard>
    );
  }
}

export { AdminContainer as AdminDashboard };



// WEBPACK FOOTER //
// ./src/views/Admin/index.js